<div class="crm-user-permissions-list-container">
  <div fxLayout="row" fxLayoutGap="15px">
    <div fxFlex="100">
<!--      <button [disabled]="!(userPermissions | async).facility.write" (click)="addUserPermissions()" mat-stroked-button color="primary"><mat-icon>add</mat-icon> <span> Dodaj</span></button>-->
    </div>
  </div>
  <table mat-table [dataSource]="users360Permissions">

    <!-- Position Column -->
    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef> Partner </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/partnerzy/szczegoly', element.partner?.uuid]">{{element.partner?.shortName ? element.partner?.shortName : ""}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="ofwca">
      <th mat-header-cell *matHeaderCellDef> Ofwca </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca?.uuid]">{{element.ofwca?.fullName ? element.ofwca?.fullName : ""}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="createdBy">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.createdBy">
          <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.createdBy?.uuid]">{{element.createdBy?.username}}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data dodania</th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="updateAt">
      <th mat-header-cell *matHeaderCellDef> Data modyfikacji</th>
      <td mat-cell *matCellDef="let element">
        {{element.updateAt | date:'y-MM-dd'}}
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
